import { Component, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { AlertType } from "src/app/constants/alert-type";
import { MemberPaths } from "src/app/constants/routes";
import { Alert } from "src/app/models/alert";
import { InPageNavItem } from "src/app/models/in-page-nav";
import { NavigationService } from "src/app/services/navigation.service";
import { SessionService } from "src/app/services/storage/session.service";
import { QLEService } from "src/app/services/qle.service";
import { MemberService } from "src/app/services/member.service";

@Component({
    selector: 'mwp-member-dashboard',
    templateUrl: './dashboard.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MemberDashboardComponent {

    public memberNameDisplay: string;
    public companyName: string;
    public systemNumber: number;
    public boxOneLabel: string;
    public boxOneValue: string;
    public boxTwoLabel: string;
    public boxTwoValue: string;
    public messageCenter: Alert[];
    public email: string;
    public divisionCaption: string;
    public division: string;
    public isPayroll: boolean;

    public navItems: InPageNavItem[];

    public dashboardBanner: string;

    constructor(
        private sessionService: SessionService,
        private navService: NavigationService,
        private router: Router,
        private qleService: QLEService,
        private memberService: MemberService
    ) {
        this.dashboardBanner = this.sessionService.session.member.dashboardTemplate;
        this.memberNameDisplay = ` ${this.sessionService.session.member.firstName}!`;
        this.companyName = this.sessionService.session.member.companyName;
        this.systemNumber = this.sessionService.session.member.systemNumber;
        this.messageCenter = this.sessionService.session.member.messageCenterAlerts;
        this.navItems = this.navService.buildDashboardInPageNavItems();
        this.isPayroll = this.sessionService.session.member.usePayrollModule && !this.sessionService.session.isAgent;
        this.divisionCaption = this.sessionService.session.member.divisionCaption;
        this.division = this.sessionService.session.member.division;
        this.email = this.sessionService.session.member.email;

        if (this.isPayroll) {
            this.boxOneLabel = "AVAILABLE PTO";
            this.boxOneValue = this.sessionService.session.member.availablePTO;
            this.boxTwoLabel = "AVAILABLE SICK TIME";
            this.boxTwoValue = this.sessionService.session.member.availableSickTime;
        }

        if (!this.sessionService.session.member.messageCenterAlerts) {
            this.memberService.getMessageCenter().subscribe((response: Alert[]) => {
                this.messageCenter = response;
            });
        } else {
            this.messageCenter = this.sessionService.session.member.messageCenterAlerts;
        }
    }

    public bannerClick(event: any): void {
        if (event.target instanceof HTMLAnchorElement) {
            switch (event.target.getAttribute('(click)')) {
                case 'goToAvaliableEnrollments()':
                    this.router.navigateByUrl(MemberPaths.BenefitsDashboard);
                    break;

                case 'goToAvaliableBenefits()':
                    this.router.navigateByUrl(MemberPaths.BenefitsAvailable);
                    break;

                case 'goToMyBenefits()':
                    this.router.navigateByUrl(MemberPaths.BenefitsMyBenefits);
                    break;

                case 'goToBenefitRequests()':
                    this.router.navigateByUrl(MemberPaths.BenefitsChangeRequests);
                    break;

                case 'goToLifeEventRequests()':
                    this.router.navigateByUrl(MemberPaths.BenefitsLifeEventRequests);
                    break;

                case 'goToResources()':
                    this.router.navigateByUrl(MemberPaths.Documents);
                    break;

                case 'goToProfile()':
                    this.router.navigateByUrl(MemberPaths.Profile);
                    break;
            }
        }
    }

    public messageCenterButtonClick(message: Alert): void {
        switch(message.alertType) {
            case AlertType.enrollment:
                this.router.navigateByUrl(MemberPaths.BenefitsDashboard);
                break;

            case AlertType.lifeEventRequest:
                this.qleService.dashboardQLEId = message.dataId;
                this.router.navigateByUrl(MemberPaths.BenefitsLifeEventRequests);
                break;
        }
    }
}